import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { SuiContainer, SuiLabel } from '@splashthat/sui';
import FontPickerEditor from 'common/components/FontPicker';
import ColorPickerEditor from 'common/components/ColorPicker';
import { TICKET_TYPE_STANDALONE, TICKET_TYPE_NESTED, TICKET_TYPE_ADD_ON } from 'common/entities/ticketType/selectors';
import { getColors } from 'common/entities/color/selectors';
import { getFonts } from 'common/entities/font/selectors';
import { styleShapePropTypes } from 'common/entities/form/styleConfiguration/utils';
import { COLLAPSIBLE_CONTENT, COLLAPSIBLE_SECTION } from '../../../../constants/reusableClassNames';
import { DEFAULT_PANEL_FONT_LABEL } from '../../../../constants/formStyleLabels';
import { getOpenTicketStylingType } from '../../../../selectors';
import { FONT_LABEL_QA } from '../../../../utils/qaIdConstants';

const DefaultFontStylePanel = ({
    formId,
    colorList,
    fontList,
    ticketPanelQaId,
    openTicketType,
    componentLabel,
    ...props
}) => (
    <SuiContainer className={COLLAPSIBLE_CONTENT} data-qa={`${ticketPanelQaId}--panel`}>
        <SuiContainer className={COLLAPSIBLE_SECTION} data-qa={`${ticketPanelQaId}--section-${FONT_LABEL_QA}`}>
            <SuiLabel text={`${componentLabel} ${DEFAULT_PANEL_FONT_LABEL}`} data-qa={`${ticketPanelQaId}--label`} />
            <FontPickerEditor
                fontFamilyList={fontList}
                defaultFontFamily={props.font}
                onChangeFontFamily={(id) => props.setTicketPanelFontFamily(formId, id, openTicketType)}
                defaultFontSize={props.fontSize}
                onChangeFontSize={(size) => props.setTicketPanelFontSize(formId, size, openTicketType)}
                fontFamilyQa={`${ticketPanelQaId}--fontFamily`}
                fontSizeQa={`${ticketPanelQaId}--fontSize`}
            />
            <ColorPickerEditor
                colorList={colorList}
                firstColor={props.color}
                changeFirstColor={(id) => props.setTicketPanelTextColor(formId, id, openTicketType)}
                qaId={ticketPanelQaId}
            />
        </SuiContainer>
    </SuiContainer>
);

DefaultFontStylePanel.propTypes = {
    openTicketType: PropTypes.oneOf([TICKET_TYPE_STANDALONE, TICKET_TYPE_NESTED, TICKET_TYPE_ADD_ON]).isRequired,
    colorList: PropTypes.arrayOf(PropTypes.object).isRequired,
    fontList: PropTypes.arrayOf(PropTypes.object).isRequired,
    ticketPanelQaId: PropTypes.string.isRequired,
    formId: PropTypes.string.isRequired,
    color: styleShapePropTypes.isRequired,
    font: styleShapePropTypes.isRequired,
    fontSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    setTicketPanelFontFamily: PropTypes.func.isRequired,
    setTicketPanelFontSize: PropTypes.func.isRequired,
    setTicketPanelTextColor: PropTypes.func.isRequired,
    componentLabel: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
    colorList: getColors(state),
    fontList: getFonts(state),
    openTicketType: getOpenTicketStylingType(state),
});

export default connect(mapStateToProps, {})(DefaultFontStylePanel);
